var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-flex",class:{ mobile: _vm.mobile },style:({ justifyContent: _vm.justifyContent, alignItems: _vm.alignItems, pointerEvents: _vm.pointerEvents })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }